export default "__VITE_ASSET__BZcGCHL8__"